export const OPEN_SIGNUP_MODAL = 'OPEN_SIGNUP_MODAL';
export const CLOSE_SIGNUP_MODAL = 'CLOSE_SIGNUP_MODAL';
export const OPEN_SUBSCRIBE_MODAL = 'OPEN_SUBSCRIBE_MODAL';
export const CLOSE_SUBSCRIBE_MODAL = 'CLOSE_SUBSCRIBE_MODAL';
export const OPEN_COMPANY_SIGNUP_MODAL = 'OPEN_COMPANY_SIGNUP_MODAL';
export const OPEN_INFLUENCER_SIGNUP_MODAL = 'OPEN_INFLUENCER_SIGNUP_MODAL';

export const LOGIN_ERROR = 'LOGIN_ERROR';
export const LOGIN_SUCCESS = 'LOGIN_ERROR';
export const SIGNUP_SUBMITTED = 'SIGNUP_STARTED';
export const SIGNUP_ERROR = 'SIGNUP_ERROR';
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';
export const SIGNOUT_SUCCESS = 'SIGNOUT_SUCCESS';

export const COMPANY_SAVE_SUCCESS = 'COMPANY_SAVE_SUCCESS';
export const COMPANY_SAVE_FAILURE = 'COMPANY_SAVE_FAILURE';
export const INFLUENCER_SAVE_SUCCESS = 'INFLUENCER_SAVE_SUCCESS';
export const INFLUENCER_SAVE_FAILURE = 'INFLUENCER_SAVE_FAILURE';

export const CAMPAIGN_SAVE_SUCCESS = 'CAMPAIGN_SAVE_SUCCESS';
export const CAMPAIGN_SAVE_FAILURE = 'CAMPAIGN_SAVE_SUCCESS';
export const CAMPAIGN_RETIRE_SUCCESS = 'CAMPAIGN_RETIRE_SUCCESS';
export const CAMPAIGN_RETIRE_FAILURE = 'CAMPAIGN_RETIRE_FAILURE';

export const INFLUENCER_INTERESTED_SUCCESS = 'INFLUENCER_INTERESTED_SUCCESS';
export const INFLUENCER_INTERESTED_FAILURE = 'INFLUENCER_INTERESTED_FAILURE';
export const COMPANY_INTERESTED_SUCCESS = 'COMPANY_INTERESTED_SUCCESS';
export const COMPANY_INTERESTED_FAILURE = 'COMPANY_INTERESTED_FAILURE';
export const INFLUENCER_MATCH_SUCCESS = 'INFLUENCER_MATCH_SUCCESS';
export const COMPANY_MATCH_SUCCESS = 'COMPANY_MATCH_SUCCESS';
export const MATCH_FAILURE = 'MATCH_FAILURE';
export const MATCH_REJECT_SUCCESS = 'MATCH_REJECT_SUCCESS';
export const MATCH_REJECT_FAILURE = 'MATCH_REJECT_FAILURE';
export const DEAL_PROPOSAL_SUCCESS = 'DEAL_PROPOSAL_SUCCESS';
export const DEAL_PROPOSAL_FAILURE = 'DEAL_PROPOSAL_FAILURE';
export const UNMATCH_SUCCESS = 'UNMATCH_SUCCESS';
export const UNMATCH_FAILURE = 'UNMATCH_FAILURE';
export const REJECT_PROPOSAL_SUCCESS = 'REJECT_SUCCESS';
export const REJECT_PROPOSAL_FAILURE = 'REJECT_FAILURE';
export const REVISION_REQUEST_SUCCESS = 'REVISION_REQUEST_SUCCESS';
export const REVISION_REQUEST_FAILURE = 'REVISION_REQUEST_FAILURE';
export const ACCEPT_DEAL_SUCCESS = 'ACCEPT_DEAL_SUCCESS';
export const ACCEPT_DEAL_FAILURE = 'ACCEPT_DEAL_FAILURE';
export const OPEN_DISPUTE_SUCCESS = 'OPEN_DISPUTE_SUCCESS';
export const OPEN_DISPUTE_FAILURE = 'OPEN_DISPUTE_FAILURE';
export const ARCHIVE_SUCCESS = 'ARCHIVE_SUCCESS';
export const ARCHIVE_FAILURE = 'ARCHIVE_FAILURE';

export const VIEW_PROPOSAL = 'VIEW_PROPOSAL';
export const CLOSE_VIEW_PROPOSAL = 'CLOSE_VIEW_PROPOSAL';

export const OPEN_ESCROW_VIEW = 'OPEN_ESCROW_VIEW';
export const CLOSE_ESCROW_VIEW = 'CLOSE_ESCROW_VIEW';

export const CLOSE_NOTIFICATION = 'CLOSE_NOTIFICATION';

export const YOUTUBE_UPLOADS_LOADED = 'YOUTUBE_UPLOADS_LOADED';
export const YOUTUBE_UPLOADS_LOAD_FAILURE = 'YOUTUBE_UPLOADS_LOAD_FAILURE';

export const ESCROW_PROCESS_SUCCESS = 'ESCROW_PROCESS_SUCCESS';
export const ESCROW_PROCESS_FAILURE = 'ESCROW_PROCESS_FAILURE';
export const ESCROW_PROCESS_STARTED = 'ESCROW_PROCESS_STARTED';

export const RELEASE_ESCROW_PROCESS_SUCCESS = 'RELEASE_ESCROW_PROCESS_SUCCESS';
export const RELEASE_ESCROW_PROCESS_FAILURE = 'RELEASE_ESCROW_PROCESS_FAILURE';
export const RELEASE_ESCROW_PROCESS_STARTED = 'RELEASE_ESCROW_PROCESS_STARTED';

export const PAYOUT_PROCESS_STARTED = 'PAYOUT_PROCESS_STARTED';
export const PAYOUT_PROCESS_FAILURE = 'PAYOUT_PROCESS_FAILURE';
export const PAYOUT_PROCESS_SUCCESS = 'PAYOUT_PROCESS_SUCCESS';

export const USER_PAYPAL_INFO_SUCCESS = 'USER_PAYPAL_INFO_SUCCESS';
export const USER_PAYPAL_INFO_FAILURE = 'USER_PAYPAL_INFO_FAILURE';

export const OPEN_COMPLETE_DEAL_FORM = 'OPEN_COMPLETE_DEAL_FORM';
export const CLOSE_COMPLETE_DEAL_FORM = 'CLOSE_COMPLETE_DEAL_FORM';

export const OPEN_REVIEW_CONTENT_VIEW = 'OPEN_REVIEW_CONTENT_VIEW';
export const CLOSE_REVIEW_CONTENT_VIEW = 'CLOSE_REVIEW_CONTENT_VIEW';

export const SUBMIT_CONTENT_FAILURE = 'SUBMIT_CONTENT_FAILURE';
export const SUBMIT_CONTENT_SUCCESS = 'SUBMIT_CONTENT_SUCCESS';

export const RELEVANT_INFLUENCER_LOAD_SUCCESS =
  'RELEVANT_INFLUENCER_LOAD_SUCCESS';
export const RELEVANT_INFLUENCER_LOAD_FAILURE =
  'RELEVANT_INFLUENCER_LOAD_FAILURE';

export const PRODUCT_ADD_SUCCESS = 'PRODUCT_ADD_SUCCESS';
export const PRODUCT_ADD_FAILURE = 'PRODUCT_ADD_FAILURE';

export const RELEVANT_CAMPAIGNS_LOAD_SUCCESS =
  'RELEVANT_CAMPAIGNS_LOAD_SUCCESS';
export const RELEVANT_CAMPAIGNS_LOAD_FAILURE =
  'RELEVANT_CAMPAIGNS_LOAD_FAILURE';

export const USER_SEARCH_SUCCESS = 'USER_SEARCH_SUCCESS';
export const USER_SEARCH_ERROR = 'USER_SEARCH_ERROR';

export const RATING_ADD_SUCCESS = 'RATING_ADD_SUCCESS';
export const RATING_ADD_FAILURE = 'RATING_ADD_FAILURE';

export const RESET_PASSWORD_EMAIL_SEND_SUCCESS =
  'RESET_PASSWORD_EMAIL_SEND_SUCCESS';
export const RESET_PASSWORD_EMAIL_SEND_FAILURE =
  'RESET_PASSWORD_EMAIL_SEND_FAILURE';

export const CONTENT_COMPLETE_SUCCESS = 'CONTENT_COMPLETE_SUCCESS';
export const CONTENT_COMPLETE_FAILURE = 'CONTENT_COMPLETE_FAILURE';

export const ACCEPT_DEAL_STARTED = 'ACCEPT_DEAL_STARTED';

export const GET_CAMPAIGN_HISTORICAL_SUCCESS =
  'GET_CAMPAIGN_HISTORICAL_SUCCESS';
export const GET_CAMPAIGN_HISTORICAL_FAILURE =
  'GET_CAMPAIGN_HISTORICAL_FAILURE';

export const GET_COMPANY_FINANCES_STARTED = 'GET_COMPANY_FINANCES_STARTED';
export const GET_COMPANY_FINANCES_SUCCESS = 'GET_COMPANY_FINANCES_SUCCESS';
export const GET_COMPANY_FINANCES_FAILURE = 'GET_COMPANY_FINANCES_FAILURE';

export const UPDATE_COMPANY_BALANCE_SUCCESS = 'UPDATE_COMPANY_BALANCE_SUCCESS';
export const UPDATE_COMPANY_BALANCE_FAILURE = 'UPDATE_COMPANY_BALANCE_FAILURE';

export const PAY_WITH_BALANCE_SUCCESS = 'PAY_WITH_BALANCE_SUCCESS';
export const PAY_WITH_BALANCE_FAILURE = 'PAY_WITH_BALANCE_FAILURE';

export const NO_ACTIVE_CAMPAIGNS = 'NO_ACTIVE_CAMPAIGNS';



// WEBPACK FOOTER //
// ./src/store/constants.js